module.exports = __webpack_public_path__ + "img/scene4.bd87033a.gif";